"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiSecretRegistrationUserAccessType = exports.ApiSecretRegistrationTargetAudience = exports.ApiSecretRegistrationAppType = void 0;
var ApiSecretRegistrationAppType;
(function (ApiSecretRegistrationAppType) {
    ApiSecretRegistrationAppType["SpecificApp"] = "SpecificApp";
    ApiSecretRegistrationAppType["AnyApp"] = "AnyApp";
})(ApiSecretRegistrationAppType || (exports.ApiSecretRegistrationAppType = ApiSecretRegistrationAppType = {}));
var ApiSecretRegistrationTargetAudience;
(function (ApiSecretRegistrationTargetAudience) {
    ApiSecretRegistrationTargetAudience["HomeTenant"] = "HomeTenant";
    ApiSecretRegistrationTargetAudience["AnyTenant"] = "AnyTenant";
})(ApiSecretRegistrationTargetAudience || (exports.ApiSecretRegistrationTargetAudience = ApiSecretRegistrationTargetAudience = {}));
var ApiSecretRegistrationUserAccessType;
(function (ApiSecretRegistrationUserAccessType) {
    ApiSecretRegistrationUserAccessType["Read"] = "Read";
    ApiSecretRegistrationUserAccessType["ReadWrite"] = "ReadWrite";
})(ApiSecretRegistrationUserAccessType || (exports.ApiSecretRegistrationUserAccessType = ApiSecretRegistrationUserAccessType = {}));
//# sourceMappingURL=ApiSecretRegistration.js.map